import { Controller } from "@hotwired/stimulus"

// Public card statement mini-login. The QR (NfcCard#uuid) is the second factor:
// the qr-scanner child dispatches a bubbling qr:read { code }, we stash it in the
// hidden uuid field and submit as soon as both factors are present.
//
// Deliberately NOT nfc-code-input, which fills a field the same way: the screens
// that use it pair it with an nfc-reader, and a chip tap yields the chip's own
// serial — chip_uid, which the server rejects as a credential on purpose, since any
// phone can skim it off a card in someone's pocket. Offering the holder NFC here
// would be offering them a guaranteed failure.
//
// No addEventListener here: the qr:read binding is declarative (data-action), so
// Stimulus unbinds it on disconnect. The bind-once/store-the-bound-fn rule applies
// to manual window/element listeners, which this has none of.
export default class extends Controller {
  static targets = ["uuid", "shortCode", "status"]

  static SCANNED_MESSAGE = "QR do cartão lido ✓"

  scanned(event) {
    this.uuidTarget.value = event.detail.code

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = this.constructor.SCANNED_MESSAGE
    }

    // Both factors in hand: go. Otherwise put the cursor where the holder still
    // has to type instead of leaving them looking at a filled-in nothing.
    if (this.shortCodeTarget.value.trim().length > 0) {
      this.element.requestSubmit()
    } else {
      this.shortCodeTarget.focus()
    }
  }
}
